import axios from 'axiosConfig';

export const getAllLoanInfo = () => axios.post("/api/reports/loaninfo", {});
export const getAllCity = () => axios.get("/api/reports/city", {});
export const getLoanOfficers = () => axios.get("/api/reports/loanofficer", {});
export const getReportNames = () => axios.get("/api/reports/reportnames", {});
export const getFundSource = () => axios.get("/api/reports/fundsource", {});
export const getAllCounty = () => axios.get("/api/reports/county", {});
export const getAllLoanStatus = () => axios.post("/api/users/loanstatus", {});


export const getReportData = (params) =>
    axios.post("/api/reports/reportdata",
        params,
    );

